import React, { useEffect, useState } from 'react';
import {
  Box,
  Container, Divider, MenuItem, Skeleton, Stack, Tab, Tabs, TextField,
} from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FmdGoodOutlined } from '@mui/icons-material';
import 'react-medium-image-zoom/dist/styles.css';
import { useDispatch } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import Elements from '../../../Elements';
import ROUTES from '../../../../Configs/routes';
import Images from '../../../../Configs/images';
import { getRequestHistory } from '../../../../Redux/Models/request';
import { getUserData } from '../../../../Utils/storages';

export default function History({
  classes,
  isLoading,
  histories,
  currentPage,
  totalPage,
}) {
  const user = getUserData();
  const role = user?.role_id?.toLowerCase();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [query, setQuery] = useSearchParams();
  const [status, setStatus] = useState('all');
  const { t } = useTranslation();

  const [page, setPage] = useState(1);
  const [items, setItems] = useState([]);

  const activeTab = query.get('tab') || 'all';

  useEffect(() => {
    if (currentPage > 1) {
      setItems([...items, ...histories]);
    } else if (currentPage === 1) {
      setItems(histories);
    }
  }, [currentPage]);

  const loadMore = () => {
    setPage((p) => p + 1);
  };

  useEffect(() => {
    setItems([]);
    setPage(1);
    dispatch(getRequestHistory(user.id, activeTab === 'all' ? '' : activeTab, status === 'all' ? '' : status, page));
  }, [activeTab, status]);

  useEffect(() => {
    dispatch(getRequestHistory(user.id, activeTab === 'all' ? '' : activeTab, status === 'all' ? '' : status, page));
  }, [page]);

  const handleChangeTab = (e, newActiveTab) => {
    setQuery({ tab: newActiveTab });
  };

  return (
    <div className={classes.root}>
      <Elements.Navigator title={t('history.title')} nav={navigate} onBack={() => navigate(ROUTES.home(), 'replace')} />
      <Container>
        <Box sx={{
          borderBottom: 1,
          borderColor: 'divider',
        }}
        >
          <Tabs
            variant="scrollable"
            value={activeTab}
            className={`${classes.tabs} mt-1`}
            onChange={handleChangeTab}
          >
            <Tab label={t('common.all')} value="all" disableRipple />
            <Tab label={t('common.reqIn')} value="Request In" disableRipple />
            <Tab label={t('common.reqOut')} value="Request Out" disableRipple />
          </Tabs>
        </Box>

        <Box mt={1.5}>
          <TextField
            select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            size="small"
            sx={{ width: '50%' }}
          >
            <MenuItem value="all">{t('history.allStat')}</MenuItem>
            <MenuItem value="Success">{t('history.stat1')}</MenuItem>
            <MenuItem value="On-progress">{t('history.stat2')}</MenuItem>
            <MenuItem value="Scheduled">{t('history.stat3')}</MenuItem>
            <MenuItem value="Canceled">{t('history.stat4')}</MenuItem>
          </TextField>
        </Box>

        <Stack direction="column" gap={2} my={2}>
          <InfiniteScroll
            next={loadMore}
            hasMore={Boolean(totalPage > currentPage)}
            dataLength={items.length}
          >
            {items.map((history) => (
              <Box
                key={history.id}
                p={1.5}
                boxShadow="1px 1px 2px rgba(0, 0, 0, 0.02)"
                border="1px solid #F5F6F8"
                borderRadius="10px"
                display="flex"
                alignItems="flex-start"
                gap={1.5}
                mb={1}
                onClick={() => {
                  if (role === 'user') {
                    navigate(history.id);
                  }
                }}
              >
                <img alt={history.type} src={history.type === 'Request In' ? Images.OenoIn : Images.OenoOut} />
                <Box flex={1}>
                  <Box>
                    <div className="s-12 weight-700">
                      {history.status}
                    </div>
                    <div className="s-10">
                      {history.pickup_address?.city}
                      ,
                      {' '}
                      {history.pickup_address?.province}
                      ,
                      {' '}
                      {history.pickup_address?.country}
                    </div>
                  </Box>
                  <Divider sx={{ my: 1 }} />
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <FmdGoodOutlined sx={{ fontSize: 12 }} />
                    <div className="weight-600 s-10">
                      {history.pickup_address?.name}
                    </div>
                  </Box>
                </Box>
              </Box>
            ))}
            {isLoading
              && [1, 2, 3].map((i) => (
                <Box key={i} p={1.5} boxShadow="1px 1px 2px rgba(0, 0, 0, 0.02)" border="1px solid #F5F6F8" borderRadius="10px" mb={1}>
                  <Box>
                    <Skeleton width={120} />
                    <Skeleton width={140} />
                  </Box>
                  <Divider sx={{ my: 1 }} />
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Skeleton width={80} />
                    <Skeleton width={40} />
                  </Box>
                </Box>
              ))}
            {!isLoading && !items.length && 'There is no data according to your filter option'}
          </InfiniteScroll>
        </Stack>
      </Container>
    </div>
  );
}
